// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSwitcher_container__TsHro","select":"LanguageSwitcher_select__JBKzH","isLight":"LanguageSwitcher_isLight__i9J5Y"};